import FormItem from "@components/formItem";
import { BANK_LIST } from "@enums";
import { PaymentContentWrapper } from "@pages/profile-v2/pages/withdraw/baseItems";
import React from "react";
import MaskInput from "react-maskinput";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, StakeInput } from "../baseItems";
import Base from "./base";

export default class BankTransfer extends Base {
	onSelectBankLocal(e) {
		this.setState(
			{
				selectedBank: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { selectedCurrency, selectedBank } = this.state;
		let bankOptions = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: "papara", label: translate("PAPARA") },
		];
		BANK_LIST.map((item) => {
			let newOpt = { value: item.id, label: item.bankName };
			bankOptions.push(newOpt);
		});
		let bank = selectedBank ? bankOptions.find((o) => o.value === selectedBank).value : 0;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<PaymentContentWrapper>
					<div>{this.getCurrencyField(translate)}</div>
					<div>
						{selectedCurrency &&
							selectedCurrency != translate("PLEASE_SELECT") &&
							this.getStakeField(translate("AMOUNT"), false)}
						{this.renderMinMax()}
					</div>
				</PaymentContentWrapper>
				<FormItem onRegister={() => this.registerField({ name: "selectedBank" })}>
					<Box>
						<BoxTitle>{translate("BANK_NAME")}</BoxTitle>
						<PaymentSelect
							options={bankOptions}
							value={bank}
							handleSelect={this.onSelectBankLocal.bind(this)}
						/>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "branchCode" })}>
					<Box>
						<BoxTitle>{translate("BRANCH_CODE")}</BoxTitle>
						<StakeInput
							autoFocus={true}
							placeholder="...................."
							onChange={this.onEnterValue.bind(this, "branchCode")}
							onLoad={() => this.registerField({ name: "branchCode" })}
						/>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "account" })}>
					<Box>
						<BoxTitle>{translate("BANK_ACCOUNT_NO")}</BoxTitle>
						<StakeInput
							autoFocus={true}
							placeholder="...................."
							onChange={this.onEnterValue.bind(this, "account")}
							onLoad={() => this.registerField({ name: "account" })}
						/>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "ssn" })}>
					<Box>
						<BoxTitle>{translate("NATIONAL_ID_NO")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="_"
								mask="0 0 0 0 0 0 0 0 0 0 0"
								onChange={this.onEnterValue.bind(this, "ssn")}
								onLoad={() => this.registerField({ name: "ssn" })}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "fullName" })}>
					<Box>
						<BoxTitle>{translate("SENDER_FULLNAME")}</BoxTitle>
						<StakeInput
							autoFocus={true}
							placeholder="...................."
							onChange={this.onEnterValue.bind(this, "fullName")}
							onLoad={() => this.registerField({ name: "fullName" })}
						/>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "iban" })}>
					<Box>
						<BoxTitle>{translate("IBAN")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="."
								mask="\T\R00 0000 0000 0000 0000 0000 00"
								onChange={this.onEnterValue.bind(this, "iban")}
								onLoad={() => this.registerField({ name: "iban" })}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		const { stake, branchCode, selectedBank, fullName, ssn, account, iban, selectedCurrency } =
			this.state;
		this.props.externalFunc.depositBankTransfer(
			{
				amount: parseInt(stake),
				language: this.getActiveLanguageCode(),
				bankName: selectedBank,
				branchCode: branchCode,
				ssn: ssn.replaceAll(" ", ""),
				fullName: fullName,
				accountNumber: account,
				iban: iban.replaceAll(" ", ""),
				currency: selectedCurrency,
				claimsBonus: false,
			},
			(data) => {
				this.onBackToDepositPage();
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, branchCode, selectedBank, fullName, ssn, account, iban, selectedCurrency } =
			this.state;
		this.props.externalFunc.depositBankTransfer(
			{
				amount: parseInt(stake),
				language: this.getActiveLanguageCode(),
				bankName: selectedBank,
				branchCode: branchCode,
				ssn: ssn.replaceAll(" ", ""),
				fullName: fullName,
				accountNumber: account,
				iban: iban.replaceAll(" ", ""),
				currency: selectedCurrency,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.onBackToDepositPage();
			}
		);
	}
}
